import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import './AdminTable.scss'
import Input from './Input.js'
import { use } from '../Helpers.js'

function Table ({ tableSettings, updateTable = false }) {
  const {
    columns,
    data = [],
    actions = {},
    headerContent = null,
    addNew = { enabled: false, url: '/' },
    filters = false,
    pagination = false,
    rowCountInfo = true,
    rowNumbers = true
  } = tableSettings

  const [tableData, setTableData] = useState([])
  const [filterRowOpen, setFilterRowOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()

  const [paginationParams, setPaginationParams] = useState({
    pageSize: 30,
    pageNumber: 1,
    sort: 'asc'
  })

  const [filterParams, setFilterParams] = useState({})

  const [queryParams, setQueryParams] = useState(
    pagination ? { ...paginationParams, ...filterParams } : { ...filterParams }
  )

  const [paginationResults, setPaginationResults] = useState({
    totalRecords: 0,
    totalPages: 0
  })

  useEffect(() => {
    if (pagination) {
      setQueryParams({ ...filterParams, ...paginationParams })
    } else {
      setQueryParams({ ...filterParams })
    }
  }, [filterParams, paginationParams])

  const getData = async () => {
    setLoading(true)
    let _data = []
    if (actions.get) {
      _data = await actions.get(queryParams)
    }
    if (data.length != 0) {
      _data = data
    }
    if (pagination) {
      setPaginationResults({
        totalRecords: _data[0]?.totalRecords,
        totalPages: _data[0]?.totalPages
      })
    }
    setTableData(_data)
    //setTimeout(()=>{setLoading(false)},1000)
    setLoading(false)
  }

  useEffect(() => {
    if (updateTable) {
      getData()
    }
  }, [updateTable])

  useEffect(() => {
    getData()
  }, [queryParams])

  const changeUserSettings = async (key, value) => {
    pagination.settings[key] = value
  }

  const collectFilterParams = () => {
    let _filterParams = {}
    columns
      .filter(c => c.filter?.enabled)
      .forEach(c => {
        _filterParams[c.filter?.name] = use.getInputValueByName(
          c.filter?.name,
          false,
          document.getElementById('filter-row')
        )
      })
    setFilterParams(_filterParams)
    setPaginationParams({ ...paginationParams, pageNumber: 1 })
  }

  const resetFilterParams = () => {
    columns
      .filter(c => c.filter?.enabled)
      .forEach(c => {
        use.resetInputValueByName(
          c.filter?.name,
          false,
          document.getElementById('filter-row')
        )
      })
    setFilterParams({})
    setPaginationParams({ ...paginationParams, pageNumber: 1 })
  }

  return (
    <div className='admin-table'>
      <div className='actions-header'>
        <div className='left-side'>
          {addNew && addNew.enabled && (
            <Link to={addNew.url} className='add-new'>
              <span className='plus-icon'>+</span>Əlavə et
            </Link>
          )}
        </div>
        <div className='right-side'>
          {rowCountInfo && (
            <span className='record-count'>
              Say: {paginationResults.totalRecords || 0}
            </span>
          )}

          {filters && (
            <span
              className='filter'
              onClick={() => setFilterRowOpen(state => !filterRowOpen)}
            >
              <img
                className={`arrow${filterRowOpen ? ' rotated' : ''}`}
                src='/images/icons/down-arrow.png'
              />
              Axtarış
              <img className='search' src='/images/icons/search.png' />
            </span>
          )}
        </div>
      </div>
      <table className='admin-data'>
        <thead>
          <tr>
            {columns.map((column, index) => {
              return (
                <th key={index + 1} title={column.description} style={column.style}>
                  {column.title}
                </th>
              )
            })}
          </tr>
          {filters && (
            <tr
              style={filterRowOpen ? {} : { display: 'none' }}
              className='filter-row'
              id='filter-row'
            >
              {columns.map((column, index) => {
                return (
                  <td key={index + 1}>
                    {column?.filter != null && (
                      <Input
                        className='filter-input'
                        type={column.filter.type}
                        disabled={!column.filter.enabled}
                        fieldName={column.filter.name}
                        placeholder={!column.filter.enabled ? '-' : ''}
                        defaultSelectOptions={
                          column.filter.type == 'select'
                            ? [{ value: '', text: '(Bütün)' }]
                            : []
                        }
                        value={filterParams[column.filter?.name]}
                        data={column.filter.data}
                        dataSource={column.filter.dataSource}
                      />
                    )}
                    {column.type == 'actions-list' ? (
                      <div className='filter-actions'>
                        <Input
                          type={'button'}
                          label={'Sorğula'}
                          eventHandler={[
                            {
                              type: 'click',
                              handler: () => collectFilterParams()
                            }
                          ]}
                          col={{ sm: 7 }}
                          className={'action get'}
                        />
                        <Input
                          type={'button'}
                          label={'Sıfırla'}
                          eventHandler={[
                            {
                              type: 'click',
                              handler: () => resetFilterParams()
                            }
                          ]}
                          col={{ sm: 5 }}
                          className={'action reset'}
                        />
                      </div>
                    ) : null}
                  </td>
                )
              })}
            </tr>
          )}
          {headerContent && (
            <tr>
              <th className='table-sub-header' colSpan={columns.length}>
                {headerContent}
              </th>
            </tr>
          )}
        </thead>
        <tbody>
          {tableData &&
            tableData.length > 0 &&
            tableData.map((d, index) => {
              return (
                <tr key={index + 1}>
                  {columns.map((column, index) => {
                    let key = index + 1
                    let propertyIsArray = Array.isArray(column.property)
                    let value
                    if (propertyIsArray) {
                      value = []
                      column.property.forEach(p => {
                        if (p.includes('.')) {
                          let v
                          let _properties = p.split('.')
                          v = d
                          _properties.forEach(_property => (v = v[_property]))
                          value.push(v)
                        } else {
                          value.push(d[p])
                        }
                        if (!column.mutate) {
                          value = value.join(',')
                        }
                      })
                    } else {
                      if (column.property.includes('.')) {
                        let _properties = column.property.split('.')
                        value = d
                        _properties.forEach(
                          _property => (value = value[_property])
                        )
                      } else {
                        value = d[column.property]
                      }
                    }

                    if (column.type != 'actions-list' && column.mutate) {
                      value = column.mutate(value)
                    }

                    switch (column.type) {
                      case 'actions-list':
                        let operationsList = column.operations(value)
                        return (
                          <td className={column.type} key={key}>
                            <div className='actions-container'>
                            {operationsList.map((o,idx) => {
                              switch (o.type) {
                                case 'link':
                                  return (
                                    <Link key={idx} to={o.link}>
                                      {o.iconType == 'path' ? (
                                        <img className='action-icon' src={o.icon} />
                                      ) : (
                                        `${o.icon}`
                                      )}
                                    </Link>
                                  )
                                case 'command':
                                  let commandParams = new URLSearchParams({
                                    requestType: 'command',
                                    commandName: o.name,
                                    warning:o.warning,
                                    parameters: o.parameters,
                                    token:'xy103'
                                  })

                                  return (
                                    <Link key={idx} title={o.title} onClick={(e)=>{e.preventDefault();setSearchParams(commandParams)}}>
                                      {o.iconType == 'path' ? (
                                        <img
                                          style={o.iconStyle}
                                          className='action-icon'
                                          title={o.title}
                                          src={o.icon}
                                        />
                                      ) : (
                                        <span style={o.iconStyle}>{o.icon}</span>
                                      )}
                                    </Link>
                                  )
                                default:
                                  return <></>
                              }
                            })}
                            </div>
                          </td>
                        )
                      case 'image':
                        return (
                          <td key={key}>
                            <img src={value} />
                          </td>
                        )
                      case 'label':
                        return (
                          <td className='label' key={key}>
                            {value}
                          </td>
                        )
                      case 'labels':
                        return (
                          <td className='labels' key={key}>
                            {value?.map((v, index) => (
                              <span key={v + '#' + index} className='label'>
                                {v}
                              </span>
                            ))}
                          </td>
                        )
                      case 'file':
                        return value ? (
                          <td className='file' key={key}>
                            {value}
                          </td>
                        ) : (
                          <td></td>
                        )
                      case 'checkbox':
                        return (
                          <td key={key}>
                            <input
                              type='checkbox'
                              name={column.property + '[]'}
                              readOnly
                              checked={value}
                              value={value}
                            />
                          </td>
                        )
                      case 'number':
                        return (
                          <td className="number" key={key}>
                            <span>{value}</span>
                          </td>
                        )
                      case 'status-label':
                        return (
                          <td className='status-label' key={key}>
                            <span>{value}</span>
                          </td>
                        )
                      default:
                        return (
                          <td style={column.style?.rows} key={key}>
                            {value}
                          </td>
                        )
                    }
                  })}
                </tr>
              )
            })}
        </tbody>
      </table>
      {loading && <div className='loading'>Yüklənir...</div>}
      {!loading && tableData && tableData.length === 0 && (
        <div className='no-data'>Məlumat yoxdur</div>
      )}
      <div className='table-footer'>
        {!loading &&
          pagination &&
          tableData &&
          tableData.length > 0 &&
          paginationResults.totalPages > 1 && (
            <div className='pagination-wrapper'>
              <div className='page-size'>
                <label>Sətirlər: </label>
                <select
                  value={paginationParams?.pageSize}
                  onChange={e => {
                    changeUserSettings('pageSize', +e.target.value)
                  }}
                >
                  <option value='10'>10</option>
                  <option value='20'>25</option>
                  <option value='50'>50</option>
                  <option value='100'>100</option>
                </select>
              </div>
              <div className='page-actions'>
                <button
                  className='navigation-button previous-page'
                  onClick={() => {
                    if (paginationParams.pageNumber - 1 < 1) {
                      return false
                    } else {
                      setPaginationParams({
                        ...paginationParams,
                        pageNumber: paginationParams.pageNumber - 1
                      })
                    }
                  }}
                >
                  <span>{'<'}</span>
                </button>
                <div className='page-number'>
                  <input
                    type='number'
                    className='current-page'
                    defaultValue={paginationParams.pageNumber}
                  />{' '}
                  / {paginationResults.totalPages}
                </div>
                <button
                  className='navigation-button next-page'
                  onClick={() => {
                    if (
                      paginationParams.pageNumber + 1 >
                      paginationResults.totalPages
                    ) {
                      return false
                    } else {
                      setPaginationParams({
                        ...paginationParams,
                        pageNumber: paginationParams.pageNumber + 1
                      })
                    }
                  }}
                >
                  <span>{'>'}</span>
                </button>
              </div>
            </div>
          )}
      </div>
    </div>
  )
}

export default Table
